import React from 'react';

/**
 * Shown right below an infinite-scroll table once the last page has been
 * fetched, so the user knows the scrolling stopped because there is no
 * more data (not because something is still loading).
 *
 * Renders nothing while data is loading, while more pages are available,
 * or when the table is empty (the table's own empty state covers that).
 */
const ScrollEndMessage = ({
    hasMore,
    loading,
    dataLength = 0,
    message = 'All records fetched, no further data',
    style,
}) => {
    if (loading || hasMore || !dataLength) return null;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '16px',
                color: '#8c8c8c',
                fontSize: 14,
                ...style,
            }}
        >
            {message}
        </div>
    );
};

export default ScrollEndMessage;
